var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.homepageMasthead'] = (function () {
    'use strict';

    const CONFIG = {
        FEATURE_SELECTOR: '.block-homepage-masthead__feature',
        FEATURE_ANIMATION: 'animate__fadeInUp',
        FEATURE_STAGGER: 150,
        HIGHLIGHT_SELECTOR: '.block-homepage-masthead__highlight',
        HIGHLIGHT_ANIMATION: 'animate__zoomIn',
        HIGHLIGHT_STAGGER: 150
    };

    const initialize = (block) => {
        if (!block || !block.id) return;

        const hasFeatures = block.querySelectorAll(CONFIG.FEATURE_SELECTOR).length > 0;
        const hasHighlights = block.querySelectorAll(CONFIG.HIGHLIGHT_SELECTOR).length > 0;
        if (!hasFeatures && !hasHighlights) return;

        const targets = [];
        if (hasHighlights) {
            targets.push({ selector: CONFIG.HIGHLIGHT_SELECTOR, type: CONFIG.HIGHLIGHT_ANIMATION, stagger: CONFIG.HIGHLIGHT_STAGGER });
        }
        if (hasFeatures) {
            targets.push({ selector: CONFIG.FEATURE_SELECTOR, type: CONFIG.FEATURE_ANIMATION, stagger: CONFIG.FEATURE_STAGGER });
        }

        App.ZagScrollAnimate.initialize(`#${CSS.escape(block.id)}`, { targets });
    };

    return {
        initialize
    };

})();